module.exports = __webpack_public_path__ + "img/cen_b.902b8363.svg";